<script>
  export default {
    name: 'energy-usage-stats-card',
    props: {
      usageStats: {
        type: Object,
        required: true
      }
    },
    data: () => ({}),
    computed: {},
    methods: {},
    created() {}
  }
</script>

<template>
  <v-card>
    <v-card-text class="pa-4 text-left" style="max-height: 70vh">
      <p class="font-weight-bold">TOTALS</p>

      <p class="font-weight-bold mt-12">RAW VALUES (values below are derived from)</p>
      <p class="font-weight-bold">=======================</p>
      <p class="font-weight-bold my-2">TOTALS</p>
      <p v-for="(v, i) in usageStats.totals" class="mb-0">{{ i }}: {{ v }}</p>
      <p class="font-weight-bold my-2">STATS</p>
      <p v-for="(v, i) in usageStats.stats" class="mb-0">{{ i }}: {{ v }}</p>
      <p class="font-weight-bold mb-4 mt-8">=======================</p>
      <p class="font-weight-bold my-4">**All formulas/values below applied where Load >= 200</p>

      <p class="mb-0 mt-2">
        <span class="font-weight-bold">total Watt:</span>
        {{ usageStats.stats.totalWatt }} <br />
        <span class="font-weight-caption">(total PV + total Grid)</span> <br />
        <span class="font-weight-caption">({{ usageStats.totals.PV }} + {{ usageStats.totals.Grid }})</span>
      </p>

      <p class="mb-0 mt-2">
        <span class="font-weight-bold">percent solar:</span>
        {{ usageStats.stats.percentSolar * 100 }} <br />
        <span class="font-weight-caption">(total PV / totalWatt * 100)</span><br />
        <span class="font-weight-caption">({{ usageStats.totals.PV }} / ({{ usageStats.totals.PV }} + {{ usageStats.totals.Grid }}) * 100)</span>
      </p>

      <p class="mb-0 mt-2">
        <span class="font-weight-bold">percent external:</span>
        {{ usageStats.stats.percentExternal * 100 }} <br />
        <span class="font-weight-caption">(total Grid / totalWatt * 100)</span><br />
        <span class="font-weight-caption">({{ usageStats.totals.Grid }} / ({{ usageStats.totals.PV }} + {{ usageStats.totals.Grid }}) * 100)</span>
      </p>
      <p class="mb-0 mt-2">
        <span class="font-weight-bold">total runtime:</span>
        {{ usageStats.stats.totalHours }} <br />
        <span class="font-weight-caption">(totalTime / 60)</span> <br />
        <span class="font-weight-caption">({{ usageStats.totals.time.total }} / 60)</span>
      </p>
      <p class="mb-0 mt-2">
        <span class="font-weight-bold">time on external:</span>
        {{ usageStats.stats.timeOnExternal }} <br />
        <span class="font-weight-caption">(totalTime where Grid > 0 / 60)</span> <br />
        <span class="font-weight-caption">({{ usageStats.totals.time.external }})</span>
      </p>
      <p class="mb-0 mt-2">
        <span class="font-weight-bold">time on solar & batt:</span>
        {{ usageStats.stats.timeOnSolar }} <br />
        <span class="font-weight-caption">(totalTime - time on external )</span><br />
        <span class="font-weight-caption">(({{ usageStats.totals.time.total }} - {{ usageStats.totals?.timeOnExternal || '0' }}) /60)</span>
      </p>

      <p class="mb-0 mt-2">
        <span class="font-weight-bold">total kWh used:</span>
        {{ usageStats.stats.totalkWhUsed }} <br />
        <span class="font-weight-caption">now assuming source W is actually mW and ÷ 1000</span> <br />

        <span class="font-weight-caption">((total Watt * total runtime Hours) / 1000)</span> <br />
        <span>(({{ usageStats.stats.totalWatt }} * {{ usageStats.stats.totalHours }} ) / 1000)</span>
      </p>
      <p class="mb-0 mt-2">
        <span class="font-weight-bold">solar generated kWh:</span>
        {{ usageStats.stats.totalSolarkWhUsed }} <br />
        <span class="font-weight-caption">now assuming source W is actually mW and ÷ 1000</span> <br />

        <span class="font-weight-caption">((total PV * total Solar Hours) / 1000)</span><br />
        <span>(({{ usageStats.totals.PV }} * {{ usageStats.stats.timeOnSolar }} ) / 1000)</span>
      </p>
      <p class="mb-0 mt-2">
        <span class="font-weight-bold">external power kWh:</span>
        {{ usageStats.stats.totalExternalkWhUsed }} <br />
        <span class="font-weight-caption">now assuming source W is actually mW and ÷ 1000</span> <br />

        <span class="font-weight-caption">((total Grid * total external Hours) / 1000)</span><br />
        <span>(({{ usageStats.totals.Grid }} * {{ usageStats.stats.timeOnExternal }} ) / 1000)</span>
      </p>
      <p class="mb-0 mt-2">
        <span class="font-weight-bold">% power from solar:</span>
        {{ usageStats.stats.percentSolar * 100 }} <br />
        <span class="font-weight-caption">( total PV / total Watt * 100)</span><br />
        <span class="font-weight-caption">( {{ usageStats.totals.PV }} / {{ usageStats.stats.totalWatt }} * 100)</span>
      </p>
      <p class="mb-0 mt-2">
        <span class="font-weight-bold">gallons fuel saved:</span>
        {{ usageStats.stats.gallonsFuelSaved }} <br />
        <span class="font-weight-caption">( (total Hours - time On External) * 4.1)</span> <br />
        <span class="font-weight-caption">( ({{ usageStats.stats.totalHours }} - {{ usageStats.stats.timeOnExternal }}) * 4.1)</span>
      </p>
      <p class="mb-0 mt-2">
        <span class="font-weight-bold"> fuel cost saved:</span>
        {{ usageStats.stats.fuelCostSaved }} <br />
        <span class="font-weight-caption"> (gallons saved * petrol rate)</span><br />
        <span class="font-weight-caption">( {{ usageStats.stats.gallonsFuelSaved }} * {{ usageStats.stats?.petrolRate || '0.00' }})</span>
      </p>
      <p class="mb-0 mt-2">
        <span class="font-weight-bold"> CO2 Prevented:</span>
        {{ usageStats.stats.co2Prevented }} <br />
        <span class="font-weight-caption"> (gallons saved * 22.45 / 2000)</span><br />
        <span class="font-weight-caption">( {{ usageStats.stats.gallonsFuelSaved }} * 22.45 / 2000)</span>
      </p>
      <p class="mb-0 mt-2">
        <span class="font-weight-bold"> trees saved:</span>
        {{ usageStats.stats.treesSaved }} <br />
        <span class="font-weight-caption"> (CO2 prevented * 39)</span><br />
        <span class="font-weight-caption">( {{ usageStats.stats.co2Prevented }} * 39)</span>
      </p>

      <p class="font-weight-bold mt-12">BY TRAILERS</p>
      <template v-for="trailer in usageStats.trailers">
        <div :key="trailer.id">
          <p class="font-weight-bold text-h6 mt-4 mb-1">{{ trailer.name }}</p>
          <div v-for="(data, day) in trailer.usage.daily" :key="day" class="mb-4">
            <p class="text-decoration-underline text-body-1 mb-1">{{ day }}</p>
            <div v-for="(v, i) in data" :key="i" class="mb-0">
              <div v-if="i === 'time'">
                <p class="mt-2 mb-0">Run time</p>
                <!-- <p v-for="(x, y) in data[i]" :key="y" class="mb-0">{{ y }}: {{ (x / 60).toFixed(2) }}</p> -->
                total: {{ (data[i].total / 60).toFixed(2) }}
              </div>
              <div v-else>{{ i }}: {{ v }}</div>
            </div>
          </div>
        </div>
      </template>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="$emit('close')">CLOSE</v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped></style>
